import { useObserver } from 'mobx-react-lite';
import React, { FC, CSSProperties } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import { FFDSettings } from 'kiolyn-api';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const useStyles = makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
    margin: 0
  },
  img: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  }
}));

interface FFDProps {
  ffd: FFDSettings;
}

const FrontFacingDisplay: FC<FFDProps> = ({ ffd }) => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const timeDelay = ffd.displaying_time ?? 5;
  const timeDelaySeconds = timeDelay * 1000;
  const lstImages = ffd.images ?? [];

  const handleStepChange = (step: number) => {
    setActiveStep(step);
  };

  const fullContainer: CSSProperties = {
    width: '100%',
    height: '100%'
  };

  return useObserver(() => (
    <Box className={classes.container}>
      <AutoPlaySwipeableViews
        axis={'x-reverse'}
        interval={timeDelaySeconds}
        index={activeStep}
        onChangeIndex={handleStepChange}
        containerStyle={fullContainer}
        slideStyle={fullContainer}
        style={fullContainer}
      >
        {lstImages.map((value, index) => (
          <img
            key={index}
            className={classes.img}
            src={value}
            alt={'img' + index}
          />
        ))}
      </AutoPlaySwipeableViews>
    </Box>
  ));
};

export default FrontFacingDisplay;
